const TOOLBAR_OVERALL_SHELTER_NAME = 'toolbar-overall-shelter';

export { TOOLBAR_OVERALL_SHELTER_NAME };
//# sourceMappingURL=shelter-button.js.map
